export default function withSuffix(text: string | null, suffix: string) {
  if (
    text === undefined ||
    text === null ||
    text === ''
  ) return text;
  return text + suffix;
}
